import { faBars } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

function Content() {
  return (
    <>
    <h1>
      salam
    </h1>
    </>
  )
}

export default Content